import { Checkbox, FormControlLabel } from "@material-ui/core";
import { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import ASCScale from "../contents/ASCScale";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { draggingCsLegendState } from "../../../store/CsLegendState";
import { weatherTimeWithID, WX_ID_ASCSCALE } from "../../../store/WeatherContentsState";
import { csRevision } from "../../../store/CsRevisionState";
import FlightPathModeState from "../../../store/FlightPathModeState";
import { configAscScaleLayer } from "../../map/layers/config/ConfigAscScale";

const config = configAscScaleLayer.Attributes.style.default;
const useStyles = makeStyles((theme) => ({
  box: {
    display: 'flex',
    flexDirection:'column',
    flexWrap:'wrap',
    justifyContent: 'flex-start'
  },
  columnBox: {
    display: 'flex',
    flexDirection:'row',
    flexWrap:'wrap',
    justifyContent: 'flex-start'
  },
  item: {
    position: 'relative',
    lineHeight: '30px',
    height: '30px',
    paddingLeft: '10px'
  },
  checkLabel: {
    display: 'inline-block',
    width: '62px',
    textAlign: 'left',
    fontSize:"12px"
  },
  iconWrap: {
    width: "40px",
    display: "inline-block"
  },
  label: {
    display: "inline-block",
    textAlign: 'left',
    paddingLeft: '5px',
    whiteSpace: "nowrap",
    fontSize: 13
  },
  block: {
    display: 'inline-block',
    width: '9px',
    height: '9px',
    margin: '0 auto',
    verticalAlign: "middle"
  },
  turbSev: {
    backgroundColor: config.turb_sev_color
  },
  turbModToSev: {
    backgroundColor: config.turb_mod_to_sev_color
  },
  turbMod: {
    backgroundColor: config.turb_mod_color
  },
  convMod: {
    backgroundColor: config.conv_mod_color
  },
  convLgt: {
    backgroundColor: config.conv_lgt_color
  },
  iceMod: {
    backgroundColor: config.icing_mod_color
  },
  iceLgt: {
    backgroundColor: config.icing_lgt_color
  }
}));

const drawTime = (fpMode, time) => {
  if(fpMode) {
    return <div>{time.baseTime}</div>
  } else {
    return <div>{time.validTime}&nbsp;{time.baseTime}</div>
  }
}

function LegendASCScale({contents: ascScale}) {
  const classes = useStyles();
  const [contentsState, setContentsState] = useState(ascScale.getContentsVisibleState());
  const isDragging = useRecoilValue(draggingCsLegendState)
  const setRevision = useSetRecoilState(csRevision);
  const toggleContents = event => {
    if(!isDragging) {
      const name = event.target.name;
      const checked = event.target.checked;
      ascScale.setContentsVisible(name, checked);
      setContentsState({...contentsState, [name]:checked});
      setRevision();
    }
  };
  const time = useRecoilValue(weatherTimeWithID(WX_ID_ASCSCALE));
  const fpMode = useRecoilValue(FlightPathModeState);

  return (
    <div>
      <div className="legend-contents-time cross-legend-contents-time">
        {drawTime(fpMode, time)}
      </div>
      <div className={classes.box}>
        <ul className={classes.columnBox}>
          <li className={classes.item}>
            <FormControlLabel
              control={<Checkbox checked={contentsState[ASCScale.ASC_SCALE_TURBULENCE]} onChange={toggleContents} name={ASCScale.ASC_SCALE_TURBULENCE} size='small'/>}
              label={<span className={classes.checkLabel}>Turbulence</span>}
            />
          </li>
          <li className={classes.item}>
            <span className={classes.iconWrap}><span className={`${classes.block} ${classes.turbSev}`}/></span><span className={classes.label}>SEV</span>
          </li>
          <li className={classes.item}>
            <span className={classes.iconWrap}><span className={`${classes.block} ${classes.turbModToSev}`}/></span><span className={classes.label}>MODtoSEV</span>
          </li>
          <li className={classes.item}>
            <span className={classes.iconWrap}><span className={`${classes.block} ${classes.turbMod}`}/></span><span className={classes.label}>MOD</span>
          </li>
        </ul>
        <ul className={classes.columnBox}>
          <li className={classes.item}>
            <FormControlLabel
              control={<Checkbox checked={contentsState[ASCScale.ASC_SCALE_CONVECTION]} onChange={toggleContents} name={ASCScale.ASC_SCALE_CONVECTION} size='small'/>}
              label={<span className={classes.checkLabel}>Convection</span>}
            />
          </li>
          <li className={classes.item}>
            <span className={classes.iconWrap}><span className={`${classes.block} ${classes.convMod}`}/></span><span className={classes.label}>MOD</span>
          </li>
          <li className={classes.item}>
            <span className={classes.iconWrap}><span className={`${classes.block} ${classes.convLgt}`}/></span><span className={classes.label}>LGT</span>
          </li>
        </ul>
        <ul className={classes.columnBox}>
          <li className={classes.item}>
            <FormControlLabel
              control={<Checkbox checked={contentsState[ASCScale.ASC_SCALE_ICING]} onChange={toggleContents} name={ASCScale.ASC_SCALE_ICING} size='small'/>}
              label={<span className={classes.checkLabel}>Icing</span>}
            />
          </li>
          <li className={classes.item}>
            <span className={classes.iconWrap}><span className={`${classes.block} ${classes.iceMod}`}/></span><span className={classes.label}>MOD</span>
          </li>
          <li className={classes.item}>
            <span className={classes.iconWrap}><span className={`${classes.block} ${classes.iceLgt}`}/></span><span className={classes.label}>LGT</span>
          </li> 
        </ul>
      </div>
    </div>
  )
}

export default LegendASCScale;